export const fakeData = [
  {
    id: '23',
    sort: '10',
    name: 'Профессиональные квалификации',
    is_toggle: true,
    is_section: true,
    is_page: false,
    url: '',
    children: [
      {
        id: '98',
        sort: '',
        name: 'CIMA (Eng) F3 «Финансовая стратегия»',
        is_page: true,
        is_section: true,
        tag: ['36', '48', '49'],
        url: '/event/cima-eng-f3-finansovaya-strategiya/',
        children: [],
      },
      {
        id: '99',
        sort: '',
        name: 'CIMA (Rus) – Диплом «Управление бизнесом»',
        is_page: true,
        is_section: true,
        tag: ['36', '48', '49'],
        url: '/event/cima-rus-diplom-upravlenie-biznesom/',
        children: [],
      },
      {
        id: '100',
        sort: '',
        name:
          'CIPD – квалификации для руководителей и специалистов в области управления персоналом (HR)',
        is_page: true,
        is_section: true,
        tag: ['48', '49'],
        url:
          '/event/cipd-kvalifikatsii-dlya-rukovoditeley-i-spetsialistov-v-oblasti-upravleniya-personalom-hr/',
        children: [],
      },
      {
        id: '101',
        sort: '',
        name: 'ACCA (Eng) – квалификация для финансовых специалистов',
        is_page: true,
        is_section: true,
        tag: ['38', '48', '49'],
        url: '/event/acca-eng-kvalifikatsiya-dlya-finansovykh-spetsialistov/',
        children: [],
      },
      {
        id: '102',
        sort: '',
        name: 'АССА ДипИФР – Диплом по международной финансовой отчётности',
        is_page: true,
        is_section: true,
        tag: ['37', '38', '48', '49'],
        url:
          '/event/assa-dipifr-diplom-po-mezhdunarodnoy-finansovoy-otchyetnosti/',
        children: [],
      },
      {
        id: '103',
        sort: '',
        name: 'CIA – квалификация «Дипломированный внутренний аудитор»',
        is_page: true,
        is_section: true,
        tag: ['45', '48', '49'],
        url: '/event/cia-kvalifikatsiya-diplomirovannyy-vnutrenniy-auditor/',
        children: [],
      },
      {
        id: '184',
        sort: '',
        name: 'Презентация программы CIMA Rus',
        is_page: true,
        is_section: true,
        tag: ['36', '48'],
        url: '/event/prezentatsiya-programmy-cima-modul-r1/',
        children: [],
      },
      {
        id: '185',
        sort: '',
        name: 'Презентация программы CIMA (комплексный ситуационный экзамен)',
        is_page: true,
        is_section: true,
        tag: ['36', '48'],
        url:
          '/event/prezentatsiya-programmy-cima-kompleksnyy-situatsionnyy-ekzamen/',
        children: [],
      },
      {
        id: '186',
        sort: '',
        name: 'Вопрос/ответ',
        is_page: true,
        is_section: true,
        tag: ['36'],
        url: '/event/vopros-otvet/',
        children: [],
      },
      {
        id: '187',
        sort: '',
        name: 'Презентация программы CIMA Eng',
        is_page: true,
        is_section: true,
        tag: ['36', '48'],
        url: '/event/prezentatsiya-programmy-cima-f3/',
        children: [],
      },
      {
        id: '188',
        sort: '',
        name:
          'Презентация Диплома по международной финансовой отчетности (ACCA ДипИФР)',
        is_page: true,
        is_section: true,
        tag: ['37'],
        url:
          '/event/prezentatsiya-diploma-po-mezhdunarodnoy-finansovoy-otchetnosti-acca-dipifr/',
        children: [],
      },
      {
        id: '189',
        sort: '',
        name: 'ACCA (Rus) “Финансы и управление бизнесом»',
        is_page: true,
        is_section: true,
        tag: ['38'],
        url: '/event/acca-rus-finansy-i-upravlenie-biznesom/',
        children: [],
      },
      {
        id: '197',
        sort: '',
        name: 'Презентации CIA «Дипломированный внутренний аудитор»',
        is_page: true,
        is_section: true,
        tag: ['48'],
        url: '/event/prezentatsii-cia-diplomirovannyy-vnutrenniy-auditor/',
        children: [],
      },
      {
        id: '203',
        sort: '',
        name: 'CIMA (Eng) – Strategic Level',
        is_page: true,
        is_section: true,
        tag: ['36', '48'],
        url: '/event/cima-eng-strategic-level/',
        children: [],
      },
      {
        id: '240',
        sort: '',
        name:
          'Презентация программы ACCA «Финансы и управление бизнесом» на русском',
        is_page: true,
        is_section: true,
        tag: ['38'],
        url:
          '/event/prezentatsiya-programmy-acca-finansy-i-upravlenie-biznesom-na-russkom/',
        children: [],
      },
    ],
  },
  {
    id: '2',
    sort: '20',
    name: 'Программы MBA',
    is_toggle: true,
    is_section: true,
    is_page: false,
    url: '',
    children: [
      {
        id: '68',
        sort: '',
        name: 'Программы MBA в Академии PwC',
        is_page: true,
        is_section: true,
        tag: ['34', '46', '47', '49', '52'],
        url: '/event/programmy-mba-v-akademii-pwc/',
        children: [],
      },
      {
        id: '205',
        sort: '',
        name: 'MBA PwC &quot;Практика менеджмента&quot;',
        is_page: true,
        is_section: true,
        tag: [],
        url: '/event/praktika-menedzhmenta/',
        children: [],
      },
      {
        id: '206',
        sort: '',
        name:
          'MBA PwC &quot;Практика менеджмента&quot; с профессиональной специализацией',
        is_page: true,
        is_section: true,
        tag: [],
        url:
          '/event/praktika-menedzhmenta-s-professionalnoy-spetsializatsiey-new/',
        children: [],
      },
      {
        id: '207',
        sort: '',
        name:
          'MBA PwC &quot;Практика менеджмента&quot; с профессиональной и международной специализациями',
        is_page: true,
        is_section: true,
        tag: [],
        url:
          '/event/praktika-menedzhmenta-s-professionalnoy-i-mezhdunarodnoy-spetsializatsiyami-new/',
        children: [],
      },
      {
        id: '208',
        sort: '',
        name:
          'МВА PwC с отраслевой специализацией &quot;Фармацевтический бизнес&quot;',
        is_page: true,
        is_section: true,
        tag: [],
        url:
          '/event/mva-s-otraslevoy-spetsializatsiey-farmatsevticheskiy-biznes-new/',
        children: [],
      },
      {
        id: '209',
        sort: '',
        name: 'MBA-Intensive. Курс для лидеров бизнеса',
        is_page: true,
        is_section: true,
        tag: [],
        url: '/event/mba-intensive-kurs-dlya-liderov-biznesa-new/',
        children: [],
      },
      {
        id: '210',
        sort: '',
        name: 'MBA-Intensive. Менеджмент в электроэнергетике',
        is_page: true,
        is_section: true,
        tag: [],
        url: '/event/mba-intensive-menedzhment-v-elektroenergetike-new/',
        children: [],
      },
      {
        id: '212',
        sort: '',
        name: 'Презентация',
        is_page: true,
        is_section: true,
        tag: [],
        url: '/event/prezentatsiya-new/',
        children: [],
      },
      {
        id: '213',
        sort: '',
        name: 'Как поступить',
        is_page: true,
        is_section: true,
        tag: [],
        url: '/event/kak-postupit-na-kursy-new/',
        children: [],
      },
      {
        id: '214',
        sort: '',
        name: 'Методика обучения',
        is_page: true,
        is_section: true,
        tag: [],
        url: '/event/metodika-obucheniya-new/',
        children: [],
      },
      {
        id: '215',
        sort: '',
        name: 'Преподаватели',
        is_page: true,
        is_section: true,
        tag: [],
        url: '/event/prepodavateli-new/',
        children: [],
      },
      {
        id: '216',
        sort: '',
        name: 'Профиль группы',
        is_page: true,
        is_section: true,
        tag: [],
        url: '/event/profil-gruppy-new/',
        children: [],
      },
      {
        id: '217',
        sort: '',
        name: 'Электронный учебный центр',
        is_page: true,
        is_section: true,
        tag: [],
        url: '/event/uchebnyy-tsentr-new/',
        children: [],
      },
    ],
  },
  {
    id: '15',
    sort: '30',
    name: 'Стратегия, финансы, управление',
    is_toggle: true,
    is_section: true,
    is_page: false,
    url: '',
    children: [
      {
        id: '16',
        sort: '100',
        name: 'Корпоративные финансы',
        is_toggle: true,
        is_section: true,
        is_page: false,
        url: '',
        children: [
          {
            id: '112',
            sort: '',
            name: 'Оценка стоимости компании',
            is_page: true,
            is_section: true,
            tag: ['46', '52', '243', '252'],
            url: '/event/otsenka-stoimosti-kompanii/',
            children: [],
          },
          {
            id: '113',
            sort: '',
            name: 'Слияния и поглощения компаний',
            is_page: true,
            is_section: true,
            tag: ['46', '243', '249', '254'],
            url: '/event/sliyaniya-i-pogloshcheniya-kompaniy/',
            children: [],
          },
          {
            id: '114',
            sort: '',
            name: 'Планирование и оценка эффективности инвестиций',
            is_page: true,
            is_section: true,
            tag: ['46', '243', '253', '264', '252'],
            url: '/event/planirovanie-i-otsenka-effektivnosti-investitsiy/',
            children: [],
          },
          {
            id: '115',
            sort: '',
            name: 'Выход на IPO',
            is_page: true,
            is_section: true,
            tag: ['46', '52', '248', '254'],
            url: '/event/vykhod-na-ipo/',
            children: [],
          },
          {
            id: '116',
            sort: '',
            name: 'Эффективная презентация финансовой информации',
            is_page: true,
            is_section: true,
            tag: ['46', '255', '262', '265', '243', '253'],
            url: '/event/effektivnaya-prezentatsiya-finansovoy-informatsii/',
            children: [],
          },
          {
            id: '117',
            sort: '',
            name: 'Финансовое моделирование в MS Excel',
            is_page: true,
            is_section: true,
            tag: ['46', '243', '244', '261'],
            url: '/event/finansovoe-modelirovanie-v-ms-excel/',
            children: [],
          },
          {
            id: '118',
            sort: '',
            name: 'Финансовый анализ',
            is_page: true,
            is_section: true,
            tag: ['46', '243', '252', '264', '255', '266'],
            url: '/event/finansovyy-analiz/',
            children: [],
          },
          {
            id: '119',
            sort: '',
            name: 'Бизнес-планирование',
            is_page: true,
            is_section: true,
            tag: ['46', '246', '245', '243'],
            url: '/event/biznes-planirovanie/',
            children: [],
          },
          {
            id: '120',
            sort: '',
            name: 'MS Excel: простая магия',
            is_page: true,
            is_section: true,
            tag: ['46'],
            url: '/event/ms-excel-prostaya-magiya/',
            children: [],
          },
        ],
      },
      {
        id: '17',
        sort: '200',
        name: 'Управленческий учёт и операционная эффективность',
        is_toggle: true,
        is_section: true,
        is_page: false,
        url: '',
        children: [
          {
            id: '121',
            sort: '',
            name: 'Непрерывность бизнеса и антикризисное управление',
            is_page: true,
            is_section: true,
            tag: ['46', '251', '52'],
            url: '/event/nepreryvnost-biznesa-i-antikrizisnoe-upravlenie/',
            children: [],
          },
          {
            id: '122',
            sort: '',
            name: 'Управление казначейской функцией',
            is_page: true,
            is_section: true,
            tag: ['46', '246', '260', '257'],
            url: '/event/upravlenie-kaznacheyskoy-funktsiey/',
            children: [],
          },
          {
            id: '123',
            sort: '',
            name: 'Подготовка эффективных управленческих отчетов',
            is_page: true,
            is_section: true,
            tag: ['46', '55', '56'],
            url: '/event/podgotovka-effektivnykh-upravlencheskikh-otchetov/',
            children: [],
          },
          {
            id: '124',
            sort: '',
            name: 'Бюджет компании',
            is_page: true,
            is_section: true,
            tag: ['46', '52', '245', '246', '266'],
            url: '/event/byudzhet-kompanii/',
            children: [],
          },
          {
            id: '125',
            sort: '',
            name: 'Управленческий учёт: методики современных компаний',
            is_page: true,
            is_section: true,
            tag: ['46', '55', '254', '49'],
            url:
              '/event/upravlencheskiy-uchyet-metodiki-sovremennykh-kompaniy/',
            children: [],
          },
          {
            id: '126',
            sort: '',
            name: 'Общие центры обслуживания: внедрение и оценка эффективности',
            is_page: true,
            is_section: true,
            tag: ['46', '52', '251', '263'],
            url:
              '/event/obshchie-tsentry-obsluzhivaniya-vnedrenie-i-otsenka-effektivnosti/',
            children: [],
          },
          {
            id: '127',
            sort: '',
            name: 'Управление затратами и оборотным капиталом',
            is_page: true,
            is_section: true,
            tag: ['46', '251', '245', '252', '263'],
            url: '/event/upravlenie-zatratami-i-oborotnym-kapitalom/',
            children: [],
          },
          {
            id: '128',
            sort: '',
            name: 'Анализ исполнения бюджета',
            is_page: true,
            is_section: true,
            tag: ['46', '245', '266', '263'],
            url: '/event/analiz-ispolneniya-byudzheta/',
            children: [],
          },
        ],
      },
      {
        id: '18',
        sort: '300',
        name: 'Внутренний аудит',
        is_toggle: true,
        is_section: true,
        is_page: false,
        url: '',
        children: [
          {
            id: '129',
            sort: '',
            name: 'Внутренний аудит: риск-ориентированная методика',
            is_page: true,
            is_section: true,
            tag: ['45', '46', '52', '257'],
            url: '/event/vnutrenniy-audit-risk-orientirovannaya-metodika/',
            children: [],
          },
          {
            id: '130',
            sort: '',
            name: 'Внутренний аудит: навыки написания отчёта',
            is_page: true,
            is_section: true,
            tag: ['45', '46', '56'],
            url: '/event/vnutrenniy-audit-navyki-napisaniya-otchyeta/',
            children: [],
          },
          {
            id: '131',
            sort: '',
            name: 'Внутренний аудит: коммуникативные навыки',
            is_page: true,
            is_section: true,
            tag: ['45', '46', '259'],
            url: '/event/vnutrenniy-audit-kommunikativnye-navyki/',
            children: [],
          },
          {
            id: '132',
            sort: '',
            name: 'Внутренний аудит бизнес-процессов',
            is_page: true,
            is_section: true,
            tag: ['45', '46', '52', '257', '247', '263'],
            url: '/event/vnutrenniy-audit-biznes-protsessov/',
            children: [],
          },
          {
            id: '133',
            sort: '',
            name: 'IT аудит',
            is_page: true,
            is_section: true,
            tag: ['45', '46', '256', '257'],
            url: '/event/it-audit/',
            children: [],
          },
          {
            id: '134',
            sort: '',
            name: 'Операционный аудит процесса строительства',
            is_page: true,
            is_section: true,
            tag: ['45', '46', '257', '258'],
            url: '/event/operatsionnyy-audit-protsessa-stroitelstva/',
            children: [],
          },
        ],
      },
      {
        id: '19',
        sort: '400',
        name: 'Внутренний контроль и управление рисками',
        is_toggle: true,
        is_section: true,
        is_page: false,
        url: '',
        children: [
          {
            id: '135',
            sort: '',
            name: 'Внутренний контроль',
            is_page: true,
            is_section: true,
            tag: ['46', '52', '247', '257'],
            url: '/event/vnutrenniy-kontrol/',
            children: [],
          },
          {
            id: '136',
            sort: '',
            name: 'Управление рисками',
            is_page: true,
            is_section: true,
            tag: ['45', '46', '257', '263', '264'],
            url: '/event/upravlenie-riskami/',
            children: [],
          },
          {
            id: '137',
            sort: '',
            name: 'Противодействие мошенничеству',
            is_page: true,
            is_section: true,
            tag: ['46', '52', '45', '257'],
            url: '/event/protivodeystvie-moshennichestvu/',
            children: [],
          },
        ],
      },
      {
        id: '20',
        sort: '500',
        name: 'Управление проектами',
        is_toggle: true,
        is_section: true,
        is_page: false,
        url: '',
        children: [
          {
            id: '138',
            sort: '',
            name: 'Практика управления проектами',
            is_page: true,
            is_section: true,
            tag: ['46', '47', '257', '246'],
            url: '/event/praktika-upravleniya-proektami/',
            children: [],
          },
          {
            id: '139',
            sort: '',
            name: 'Практика управления проектами: коммуникативные навыки',
            is_page: true,
            is_section: true,
            tag: ['46', '47', '259'],
            url:
              '/event/praktika-upravleniya-proektami-kommunikativnye-navyki/',
            children: [],
          },
        ],
      },
      {
        id: '21',
        sort: '600',
        name: 'Семинары для руководителей',
        is_toggle: true,
        is_section: true,
        is_page: false,
        url: '',
        children: [
          {
            id: '140',
            sort: '',
            name: 'Финансы для нефинансовых руководителей',
            is_page: true,
            is_section: true,
            tag: ['46', '49', '255', '264', '245'],
            url: '/event/finansy-dlya-nefinansovykh-rukovoditeley/',
            children: [],
          },
          {
            id: '141',
            sort: '',
            name: 'Стратегический менеджмент',
            is_page: true,
            is_section: true,
            tag: ['46', '49', '52', '254'],
            url: '/event/strategicheskiy-menedzhment/',
            children: [],
          },
          {
            id: '142',
            sort: '',
            name: 'Корпоративное управление',
            is_page: true,
            is_section: true,
            tag: ['46', '49', '52', '247', '45', '257'],
            url: '/event/korporativnoe-upravlenie/',
            children: [],
          },
          {
            id: '143',
            sort: '',
            name: 'Интеграция компаний',
            is_page: true,
            is_section: true,
            tag: ['46', '49', '249', '254'],
            url: '/event/integratsiya-kompaniy/',
            children: [],
          },
          {
            id: '144',
            sort: '',
            name: 'Excel для руководителя',
            is_page: true,
            is_section: true,
            tag: ['46', '49', '244', '255', '264'],
            url: '/event/excel-dlya-rukovoditelya/',
            children: [],
          },
        ],
      },
      {
        id: '22',
        sort: '700',
        name: 'Финансист – лидер изменений',
        is_toggle: true,
        is_section: true,
        is_page: false,
        url: '',
        children: [
          {
            id: '145',
            sort: '',
            name: 'Модульная программа «Финансист – лидер изменений»',
            is_page: true,
            is_section: true,
            tag: ['46'],
            url: '/event/modulnaya-programma-finansist-lider-izmeneniy/',
            children: [],
          },
        ],
      },
      {
        id: '111',
        sort: '',
        name:
          'Программа семинаров &quot;Стратегия, финансы, инструменты управления&quot;',
        is_page: true,
        is_section: true,
        tag: ['46'],
        url:
          '/event/programma-seminarov-strategiya-finansy-instrumenty-upravleniya/',
        children: [],
      },
    ],
  },
  {
    id: '5',
    sort: '40',
    name: 'МСФО, РСБУ, ОПБУ США, налоги',
    is_toggle: true,
    is_section: true,
    is_page: false,
    url: '',
    children: [
      {
        id: '8',
        sort: '500',
        name: 'Налоги и вопросы трансфертного ценообразования',
        is_toggle: true,
        is_section: true,
        is_page: false,
        url: '',
        children: [
          {
            id: '91',
            sort: '',
            name: 'Налоговый мониторинг',
            is_page: true,
            is_section: true,
            tag: ['46', '247', '250', '257'],
            url: '/event/nalogovyy-monitoring/',
            children: [],
          },
          {
            id: '92',
            sort: '',
            name:
              'Анализ внутригрупповых сделок по оказанию услуг, предоставлению нематериальных активов и заемного финансирования',
            is_page: true,
            is_section: true,
            tag: ['41', '49'],
            url:
              '/event/analiz-vnutrigruppovykh-sdelok-po-okazaniyu-uslug-predostavleniyu-nematerialnykh-aktivov-i-zaemnogo-/',
            children: [],
          },
          {
            id: '93',
            sort: '',
            name:
              'Налоговое администрирование внутригрупповых сделок: теоретические и практические аспекты налоговых проверок',
            is_page: true,
            is_section: true,
            tag: ['41', '49'],
            url:
              '/event/nalogovoe-administrirovanie-vnutrigruppovykh-sdelok-teoreticheskie-i-prakticheskie-aspekty-nalogovykh/',
            children: [],
          },
          {
            id: '94',
            sort: '',
            name:
              'Новое в международных правилах трансфертного ценообразования - инициативы ОЭСР в рамках программы BEPS (Base Erosion and Profit Shifting) по вопросам трансфертного ценообразования',
            is_page: true,
            is_section: true,
            tag: ['41', '49'],
            url:
              '/event/novoe-v-mezhdunarodnykh-pravilakh-transfertnogo-tsenoobrazovaniya-initsiativy-oesr-v-ramkakh-program/',
            children: [],
          },
          {
            id: '95',
            sort: '',
            name:
              'Особенности трансфертного ценообразования в сделках по перепродаже товаров',
            is_page: true,
            is_section: true,
            tag: ['41', '49'],
            url:
              '/event/osobennosti-transfertnogo-tsenoobrazovaniya-v-sdelkakh-po-pereprodazhe-tovarov/',
            children: [],
          },
          {
            id: '96',
            sort: '',
            name:
              'Особенности трансфертного ценообразования в сделках по производству товаров',
            is_page: true,
            is_section: true,
            tag: ['41', '49'],
            url:
              '/event/osobennosti-transfertnogo-tsenoobrazovaniya-v-sdelkakh-po-proizvodstvu-tovarov/',
            children: [],
          },
          {
            id: '97',
            sort: '',
            name: 'Теоретические основы трансфертного ценообразования',
            is_page: true,
            is_section: true,
            tag: ['41', '49'],
            url:
              '/event/teoreticheskie-osnovy-transfertnogo-tsenoobrazovaniya/',
            children: [],
          },
        ],
      },
      {
        id: '7',
        sort: '500',
        name: 'Семинары для финансовых специалистов и руководителей',
        is_toggle: true,
        is_section: true,
        is_page: false,
        url: '',
        children: [
          {
            id: '89',
            sort: '',
            name: 'МСФО для руководителей, экономистов и финансистов',
            is_page: true,
            is_section: true,
            tag: ['41', '49'],
            url: '/event/msfo-dlya-rukovoditeley-ekonomistov-i-finansistov/',
            children: [],
          },
          {
            id: '90',
            sort: '',
            name: 'МСФО для банковских аналитиков',
            is_page: true,
            is_section: true,
            tag: ['41', '49'],
            url: '/event/msfo-dlya-bankovskikh-analitikov/',
            children: [],
          },
        ],
      },
      {
        id: '6',
        sort: '500',
        name: 'Семинары по МСФО, РСБУ и ОПБУ США',
        is_toggle: true,
        is_section: true,
        is_page: false,
        url: '',
        children: [
          {
            id: '74',
            sort: '',
            name: 'МСФО (IFRS) 16 «Аренда»',
            is_page: true,
            is_section: true,
            tag: ['41', '49'],
            url: '/event/msfo-ifrs-16-arenda/',
            children: [],
          },
          {
            id: '75',
            sort: '',
            name:
              'МСФО-2019: последние изменения и практические аспекты (Москва)',
            is_page: true,
            is_section: true,
            tag: ['41', '49'],
            url:
              '/event/msfo-2019-poslednie-izmeneniya-i-prakticheskie-aspekty-moskva/',
            children: [],
          },
          {
            id: '76',
            sort: '',
            name: 'РСБУ-2019: последние изменения и практические аспекты',
            is_page: true,
            is_section: true,
            tag: ['41', '49'],
            url:
              '/event/rsbu-2019-poslednie-izmeneniya-i-prakticheskie-aspekty/',
            children: [],
          },
          {
            id: '77',
            sort: '',
            name: 'МСФО: формирование и представление финансовой отчетности',
            is_page: true,
            is_section: true,
            tag: ['41', '49'],
            url:
              '/event/msfo-formirovanie-i-predstavlenie-finansovoy-otchetnosti/',
            children: [],
          },
          {
            id: '78',
            sort: '',
            name:
              'МСФО: финансовые инструменты, резервы, налоги на прибыль и другие статьи отчетности',
            is_page: true,
            is_section: true,
            tag: ['41', '49'],
            url:
              '/event/msfo-finansovye-instrumenty-rezervy-nalogi-na-pribyl-i-drugie-stati-otchetnosti/',
            children: [],
          },
          {
            id: '79',
            sort: '',
            name: 'МСФО: внеоборотные активы',
            is_page: true,
            is_section: true,
            tag: ['41', '49'],
            url: '/event/msfo-vneoborotnye-aktivy/',
            children: [],
          },
          {
            id: '80',
            sort: '',
            name: 'МСФО и РСБУ: сравнение и сближение учетной политики',
            is_page: true,
            is_section: true,
            tag: ['41', '49'],
            url: '/event/msfo-i-rsbu-sravnenie-i-sblizhenie-uchetnoy-politiki/',
            children: [],
          },
          {
            id: '81',
            sort: '',
            name: 'ОПБУ США и РСБУ: сравнение и сближение учетной политики',
            is_page: true,
            is_section: true,
            tag: ['41', '49'],
            url:
              '/event/opbu-ssha-i-rsbu-sravnenie-i-sblizhenie-uchetnoy-politiki/',
            children: [],
          },
          {
            id: '82',
            sort: '',
            name: 'МСФО (IFRS) 15 «Выручка по договорам с покупателями»',
            is_page: true,
            is_section: true,
            tag: ['41', '49'],
            url: '/event/msfo-ifrs-15-vyruchka-po-dogovoram-s-pokupatelyami/',
            children: [],
          },
          {
            id: '83',
            sort: '',
            name: 'Трансформация из РСБУ в МСФО',
            is_page: true,
            is_section: true,
            tag: ['41', '49'],
            url: '/event/transformatsiya-iz-rsbu-v-msfo/',
            children: [],
          },
          {
            id: '84',
            sort: '',
            name:
              'Раскрытие информации в финансовой отчетности по МСФО: требования, практика применения, типичные ошибки',
            is_page: true,
            is_section: true,
            tag: ['41', '49'],
            url:
              '/event/raskrytie-informatsii-v-finansovoy-otchetnosti-po-msfo-trebovaniya-praktika-primeneniya-tipichnye-osh/',
            children: [],
          },
          {
            id: '85',
            sort: '',
            name:
              'Отчет о движении денежных средств по МСФО (IAS) 7: теория и практика построения прямым и косвенным методами',
            is_page: true,
            is_section: true,
            tag: ['41', '49'],
            url:
              '/event/otchet-o-dvizhenii-denezhnykh-sredstv-po-msfo-ias-7-teoriya-i-praktika-postroeniya-pryamym-i-kosvenn/',
            children: [],
          },
          {
            id: '86',
            sort: '',
            name: 'Курс &quot;Налоги на прибыль по МСФО&quot; (IAS) 12',
            is_page: true,
            is_section: true,
            tag: ['41', '49'],
            url: '/event/kurs-nalogi-na-pribyl-po-msfo-ias-12/',
            children: [],
          },
          {
            id: '87',
            sort: '',
            name:
              'Финансовые инструменты: МСФО (IAS) 32, МСФО (IFRS) 9, МСФО (IFRS) 7',
            is_page: true,
            is_section: true,
            tag: ['41', '49'],
            url:
              '/event/finansovye-instrumenty-msfo-ias-32-msfo-ifrs-9-msfo-ifrs-7/',
            children: [],
          },
          {
            id: '88',
            sort: '',
            name:
              'Капитальное строительство 4D: РСБУ, МСФО, налоги и правовое регулирование',
            is_page: true,
            is_section: true,
            tag: ['41', '49'],
            url:
              '/event/kapitalnoe-stroitelstvo-4d-rsbu-msfo-nalogi-i-pravovoe-regulirovanie/',
            children: [],
          },
        ],
      },
      {
        id: '73',
        sort: '',
        name: 'Программа семинаров по МСФО, РСБУ, ОПБУ США, налогообложению',
        is_page: true,
        is_section: true,
        tag: ['41', '49'],
        url:
          '/event/programma-seminarov-po-msfo-rsbu-opbu-ssha-nalogooblozheniyu/',
        children: [],
      },
    ],
  },
  {
    id: '25',
    sort: '50',
    name: 'Эффективность руководителя',
    is_toggle: true,
    is_section: true,
    is_page: false,
    url: '',
    children: [
      {
        id: '26',
        sort: '500',
        name: 'Менеджмент и Лидерство',
        is_toggle: true,
        is_section: true,
        is_page: false,
        url: '',
        children: [
          {
            id: '149',
            sort: '',
            name: 'Ключевые навыки руководителя',
            is_page: true,
            is_section: true,
            tag: ['39', '49'],
            url: '/event/klyuchevye-navyki-rukovoditelya/',
            children: [],
          },
          {
            id: '150',
            sort: '',
            name: 'Управленческие навыки для топ-менеджеров',
            is_page: true,
            is_section: true,
            tag: ['39', '49'],
            url: '/event/upravlencheskie-navyki-dlya-top-menedzherov/',
            children: [],
          },
          {
            id: '151',
            sort: '',
            name: 'Управление изменениями',
            is_page: true,
            is_section: true,
            tag: ['39', '49'],
            url: '/event/upravlenie-izmeneniyami/',
            children: [],
          },
          {
            id: '152',
            sort: '',
            name: 'Эффективная обратная связь',
            is_page: true,
            is_section: true,
            tag: ['39', '46'],
            url: '/event/effektivnaya-obratnaya-svyaz/',
            children: [],
          },
          {
            id: '153',
            sort: '',
            name: 'Анализ информации и принятие решений',
            is_page: true,
            is_section: true,
            tag: ['39', '49'],
            url: '/event/analiz-informatsii-i-prinyatie-resheniy/',
            children: [],
          },
          {
            id: '154',
            sort: '',
            name: 'Источники энергии в работе',
            is_page: true,
            is_section: true,
            tag: ['39', '49'],
            url: '/event/istochniki-energii-v-rabote/',
            children: [],
          },
          {
            id: '155',
            sort: '',
            name: 'Лидерство - секреты успеха',
            is_page: true,
            is_section: true,
            tag: ['39', '49'],
            url: '/event/liderstvo-sekrety-uspekha/',
            children: [],
          },
          {
            id: '156',
            sort: '',
            name: 'Развитие навыков критического мышления',
            is_page: true,
            is_section: true,
            tag: ['39', '49'],
            url: '/event/razvitie-navykov-kriticheskogo-myshleniya/',
            children: [],
          },
          {
            id: '157',
            sort: '',
            name: 'Управление временем',
            is_page: true,
            is_section: true,
            tag: ['39', '49'],
            url: '/event/upravlenie-vremenem/',
            children: [],
          },
          {
            id: '158',
            sort: '',
            name: 'Развитие креативного мышления',
            is_page: true,
            is_section: true,
            tag: [],
            url: '/event/razvitie-kreativnogo-myshleniya/',
            children: [],
          },
        ],
      },
      {
        id: '28',
        sort: '600',
        name: 'Эффективная коммуникация',
        is_toggle: false,
        is_section: true,
        is_page: false,
        url: '',
        children: [
          {
            id: '160',
            sort: '',
            name: 'Эмоциональная компетентность',
            is_page: true,
            is_section: true,
            tag: ['39'],
            url: '/event/emotsionalnaya-kompetentnost/',
            children: [],
          },
          {
            id: '161',
            sort: '',
            name: 'Искусство публичных выступлений',
            is_page: true,
            is_section: true,
            tag: ['39'],
            url: '/event/iskusstvo-publichnykh-vystupleniy/',
            children: [],
          },
          {
            id: '162',
            sort: '',
            name: 'Управление конфликтом',
            is_page: true,
            is_section: true,
            tag: ['39'],
            url: '/event/upravlenie-konfliktom/',
            children: [],
          },
          {
            id: '163',
            sort: '',
            name: 'Управление стрессом',
            is_page: true,
            is_section: true,
            tag: ['39'],
            url: '/event/upravlenie-stressom/',
            children: [],
          },
          {
            id: '164',
            sort: '',
            name: 'Эффективное деловое письмо',
            is_page: true,
            is_section: true,
            tag: ['39'],
            url: '/event/effektivnoe-delovoe-pismo/',
            children: [],
          },
          {
            id: '165',
            sort: '',
            name: 'Эффективные переговоры',
            is_page: true,
            is_section: true,
            tag: ['39'],
            url: '/event/effektivnye-peregovory/',
            children: [],
          },
          {
            id: '166',
            sort: '',
            name: 'Навыки влияния и убеждения',
            is_page: true,
            is_section: true,
            tag: ['39'],
            url: '/event/navyki-vliyaniya-i-ubezhdeniya/',
            children: [],
          },
          {
            id: '167',
            sort: '',
            name: 'Сила &quot;Нет&quot; в переговорах',
            is_page: true,
            is_section: true,
            tag: ['39'],
            url: '/event/sila-net-v-peregovorakh/',
            children: [],
          },
          {
            id: '168',
            sort: '',
            name: 'Управление заинтересованными сторонами',
            is_page: true,
            is_section: true,
            tag: ['39'],
            url: '/event/upravlenie-zainteresovannymi-storonami/',
            children: [],
          },
        ],
      },
      {
        id: '148',
        sort: '',
        name: 'Тренинги для руководителей',
        is_page: true,
        is_section: true,
        tag: ['39', '49'],
        url: '/event/programma-seminarov-effektivnost-rukovoditelya/',
        children: [],
      },
      {
        id: '159',
        sort: '',
        name: 'Эффективная деловая коммуникация',
        is_page: true,
        is_section: true,
        tag: ['39'],
        url: '/event/effective-communication/',
        children: [],
      },
    ],
  },
  {
    id: '24',
    sort: '60',
    name: 'Цифровые технологии, анализ данных и гибкие методологии',
    is_toggle: true,
    is_section: true,
    is_page: false,
    url: '',
    children: [
      {
        id: '146',
        sort: '',
        name:
          'Программы обучения по цифровым технологиям, анализу данных и гибким методологиям',
        is_page: true,
        is_section: true,
        tag: ['53'],
        url:
          '/event/programmy-obucheniya-po-tsifrovym-tekhnologiyam-analizu-dannykh-i-gibkim-metodologiyam/',
        children: [],
      },
      {
        id: '147',
        sort: '',
        name: 'Приложение Digital Fitness 2.0 (DFA)',
        is_page: true,
        is_section: true,
        tag: [],
        url: '/event/prilozhenie-digital-fitness-2-0-dfa/',
        children: [],
      },
      {
        id: '190',
        sort: '',
        name: 'Основы Agile для бизнес-лидеров',
        is_page: true,
        is_section: true,
        tag: ['42', '51'],
        url: '/event/osnovy-agile-dlya-biznes-liderov/',
        children: [],
      },
      {
        id: '191',
        sort: '',
        name:
          'Тренинг &quot;Погружение в Agile. Тренинг для Скрам-Мастера&quot;',
        is_page: true,
        is_section: true,
        tag: ['42'],
        url: '/event/trening-pogruzhenie-v-agile-trening-dlya-skram-mastera/',
        children: [],
      },
      {
        id: '192',
        sort: '',
        name: 'Тренинг «Погружение в Agile. Тренинг для Владельца Продукта»',
        is_page: true,
        is_section: true,
        tag: ['42'],
        url:
          '/event/trening-pogruzhenie-v-agile-trening-dlya-vladeltsa-produkta/',
        children: [],
      },
      {
        id: '193',
        sort: '',
        name:
          'Мастер-класс &quot;Практическое применение анализа данных и машинного обучения для бизнес-лидеров&quot;',
        is_page: true,
        is_section: true,
        tag: ['43'],
        url:
          '/event/master-klass-prakticheskoe-primenenie-analiza-dannykh-i-mashinnogo-obucheniya-dlya-biznes-liderov/',
        children: [],
      },
      {
        id: '194',
        sort: '',
        name:
          'Практическое применение анализа данных и машинного обучения в бизнесе',
        is_page: true,
        is_section: true,
        tag: ['43'],
        url:
          '/event/prakticheskoe-primenenie-analiza-dannykh-i-mashinnogo-obucheniya-v-biznese/',
        children: [],
      },
      {
        id: '195',
        sort: '',
        name:
          'Тренинг «Применение инструментов анализа данных для клиентской аналитики. Data Mining»',
        is_page: true,
        is_section: true,
        tag: ['43'],
        url:
          '/event/trening-primenenie-instrumentov-analiza-dannykh-dlya-klientskoy-analitiki-data-mining/',
        children: [],
      },
      {
        id: '196',
        sort: '',
        name:
          'Мастер-класс «Использование технологии Process Mining для анализа бизнес-процессов компании»',
        is_page: true,
        is_section: true,
        tag: ['54'],
        url:
          '/event/master-klass-ispolzovanie-tekhnologii-process-mining-dlya-analiza-biznes-protsessov-kompanii/',
        children: [],
      },
      {
        id: '199',
        sort: '',
        name:
          'Мастер-класс &quot;Роботизация бизнес-процессов для лидеров&quot;',
        is_page: true,
        is_section: true,
        tag: ['50'],
        url:
          '/event/master-klass-robotizatsiya-biznes-protsessov-dlya-liderov/',
        children: [],
      },
      {
        id: '200',
        sort: '',
        name: 'Бизнес-игра о технологии блокчейн (Blockchain Experience Game)',
        is_page: true,
        is_section: true,
        tag: [],
        url:
          '/event/biznes-igra-o-tekhnologii-blokcheyn-blockchain-experience-game/',
        children: [],
      },
      {
        id: '218',
        sort: '',
        name:
          'Мастер-класс &quot;Цифровые технологии и Интернет вещей, меняющие бизнес&quot;',
        is_page: true,
        is_section: true,
        tag: [],
        url:
          '/event/master-klass-tsifrovye-tekhnologii-i-internet-veshchey-menyayushchie-biznes/',
        children: [],
      },
    ],
  },
  {
    id: '34',
    sort: '70',
    name: 'Лидер в цифровую эпоху',
    is_toggle: true,
    is_section: true,
    is_page: false,
    url: '',
    children: [
      {
        id: '72',
        sort: '',
        name: 'Модульная программа обучения «Лидер в цифровую эпоху»',
        is_page: true,
        is_section: true,
        tag: [],
        url: '/event/modulnaya-programma-obucheniya-lider-v-tsifrovuyu-epokhu/',
        children: [],
      },
      {
        id: '198',
        sort: '',
        name: 'Презентация модульной программы «Лидер в цифровую эпоху»',
        is_page: true,
        is_section: true,
        tag: ['49'],
        url:
          '/event/prezentatsiya-modulnoy-programmy-lider-v-tsifrovuyu-epokhu/',
        children: [],
      },
    ],
  },
  {
    id: '9',
    sort: '70',
    name: 'Семинары для финансовых организаций',
    is_toggle: true,
    is_section: true,
    is_page: false,
    url: '',
    children: [
      {
        id: '13',
        sort: '500',
        name:
          'МСФО (IFRS) 17 – начало новой эпохи в учете договоров страхования',
        is_toggle: true,
        is_section: true,
        is_page: false,
        url: '',
        children: [
          {
            id: '108',
            sort: '',
            name: '«Введение в МСФО (IFRS) 17» для страховых организаций',
            is_page: true,
            is_section: true,
            tag: ['41'],
            url:
              '/event/vvedenie-v-msfo-ifrs-17-dlya-strakhovykh-organizatsiy/',
            children: [],
          },
          {
            id: '109',
            sort: '',
            name:
              'Практикум для страховых организаций «МСФО (IFRS) 17 – подготовка сверок изменения обязательства по группе договоров страхования»',
            is_page: true,
            is_section: true,
            tag: ['41'],
            url:
              '/event/praktikum-dlya-strakhovykh-organizatsiy-msfo-ifrs-17-podgotovka-sverok-izmeneniya-obyazatelstva-po-g/',
            children: [],
          },
        ],
      },
      {
        id: '10',
        sort: '500',
        name: 'МСФО для финансовых организаций',
        is_toggle: true,
        is_section: true,
        is_page: false,
        url: '',
        children: [
          {
            id: '104',
            sort: '',
            name:
              'МСФО (IFRS) 9 «Финансовые инструменты»: особенности применения для финансовых организаций',
            is_page: true,
            is_section: true,
            tag: ['41'],
            url:
              '/event/msfo-ifrs-9-finansovye-instrumenty-osobennosti-primeneniya-dlya-finansovykh-organizatsiy/',
            children: [],
          },
        ],
      },
      {
        id: '14',
        sort: '500',
        name: 'Новые требования Банка России к управлению операционным риском',
        is_toggle: true,
        is_section: true,
        is_page: false,
        url: '',
        children: [
          {
            id: '110',
            sort: '',
            name:
              'Модель оценки финансовой устойчивости страховщиков (требования Банка России)',
            is_page: true,
            is_section: true,
            tag: ['41'],
            url:
              '/event/model-otsenki-finansovoy-ustoychivosti-strakhovshchikov-trebovaniya-banka-rossii/',
            children: [],
          },
        ],
      },
      {
        id: '12',
        sort: '500',
        name: 'Последние изменения в МСФО',
        is_toggle: true,
        is_section: true,
        is_page: false,
        url: '',
        children: [
          {
            id: '107',
            sort: '',
            name:
              'Последние изменения в МСФО для финансовых организаций: МСФО (IFRS) 9, МСФО (IFRS) 15, МСФО (IFRS) 16, МСФО (IFRS) 17)',
            is_page: true,
            is_section: true,
            tag: ['41'],
            url:
              '/event/poslednie-izmeneniya-v-msfo-dlya-finansovykh-organizatsiy-msfo-ifrs-9-msfo-ifrs-15-msfo-ifrs-16-msfo/',
            children: [],
          },
        ],
      },
      {
        id: '11',
        sort: '500',
        name: 'РСБУ для кредитных организаций',
        is_toggle: true,
        is_section: true,
        is_page: false,
        url: '',
        children: [
          {
            id: '105',
            sort: '',
            name:
              'Методология расчетов нормативов достаточности капитала для кредитной организации',
            is_page: true,
            is_section: true,
            tag: ['41'],
            url:
              '/event/metodologiya-raschetov-normativov-dostatochnosti-kapitala-dlya-kreditnoy-organizatsii/',
            children: [],
          },
          {
            id: '106',
            sort: '',
            name:
              'Практика применения кредитными организациями принципов МСФО (IFRS) 9 «Финансовые инструменты» в бухгалтерском учете',
            is_page: true,
            is_section: true,
            tag: ['41'],
            url:
              '/event/praktika-primeneniya-kreditnymi-organizatsiyami-printsipov-msfo-ifrs-9-finansovye-instrumenty-v-bukh/',
            children: [],
          },
        ],
      },
    ],
  },
  {
    id: '1',
    sort: '80',
    name: 'HR-Академия',
    is_toggle: true,
    is_section: true,
    is_page: false,
    url: '',
    children: [
      {
        id: '67',
        sort: '',
        name: 'HR-академия',
        is_page: true,
        is_section: true,
        tag: ['40', '49', '51'],
        url: '/event/hr-akademiya/',
        children: [],
      },
    ],
  },
  {
    id: '3',
    sort: '90',
    name: 'Бизнес-коучинг',
    is_toggle: true,
    is_section: true,
    is_page: false,
    url: '',
    children: [
      {
        id: '4',
        sort: '500',
        name: 'Краткосрочные семинары по развитию навыков коучинга',
        is_toggle: true,
        is_section: true,
        is_page: false,
        url: '',
        children: [
          {
            id: '70',
            sort: '',
            name: 'Карьерный коучинг',
            is_page: true,
            is_section: true,
            tag: ['35', '49'],
            url: '/event/karernyy-kouching/',
            children: [],
          },
          {
            id: '71',
            sort: '',
            name: 'Коучинг руководителей',
            is_page: true,
            is_section: true,
            tag: ['35', '49', '51'],
            url: '/event/kouching-rukovoditeley/',
            children: [],
          },
        ],
      },
      {
        id: '69',
        sort: '',
        name: 'Международная сертификация &quot;Бизнес-коучинг&quot;',
        is_page: true,
        is_section: true,
        tag: ['35', '49'],
        url: '/event/mezhdunarodnaya-sertifikatsiya-biznes-kouching/',
        children: [],
      },
    ],
  },
  {
    id: '32',
    sort: '500',
    name: 'Академия маркетинга',
    is_toggle: true,
    is_section: true,
    is_page: false,
    url: '',
    children: [
      {
        id: '33',
        sort: '500',
        name: 'Направления обучения',
        is_toggle: true,
        is_section: true,
        is_page: false,
        url: '',
        children: [],
      },
      {
        id: '178',
        sort: '',
        name: 'Академия маркетинга и продаж',
        is_page: true,
        is_section: true,
        tag: [],
        url: '/event/akademiya-marketinga-i-prodazh/',
        children: [],
      },
    ],
  },
  {
    id: '31',
    sort: '900',
    name: 'Стратегические сессии, фасилитации',
    is_toggle: true,
    is_section: true,
    is_page: false,
    url: '',
    children: [
      {
        id: '177',
        sort: '',
        name: 'Стратегические сессии, фасилитации.',
        is_page: true,
        is_section: true,
        tag: [],
        url: '/event/strategicheskie-sessii-fasilitatsii/',
        children: [],
      },
    ],
  },
  {
    id: '30',
    sort: '900',
    name:
      'Тестирование профессиональных знаний и навыков финансовых специалистов',
    is_toggle: true,
    is_section: true,
    is_page: false,
    url: '',
    children: [
      {
        id: '176',
        sort: '',
        name:
          'Тестирование профессиональных знаний и навыков финансовых специалистов',
        is_page: true,
        is_section: true,
        tag: [],
        url:
          '/event/testirovanie-professionalnykh-znaniy-i-navykov-finansovykh-spetsialistov/',
        children: [],
      },
    ],
  },
  {
    id: '39',
    sort: '500',
    name: 'Тестовый раздел',
    is_toggle: false,
    is_section: true,
    is_page: false,
    url: '',
    children: [
      {
        id: '44',
        sort: '470',
        name: 'Тестовый раздел сортировка 470',
        is_toggle: false,
        is_section: true,
        is_page: false,
        url: '',
        children: [
          {
            id: '282',
            sort: '',
            name: 'Страница внутри 2ур',
            is_page: true,
            is_section: true,
            tag: [],
            url: '/event/stranitsa-vnutri-2ur/',
            children: [],
          },
        ],
      },
      {
        id: '42',
        sort: '480',
        name: 'Тестовая страница сортировка 480',
        is_toggle: false,
        is_section: true,
        is_page: false,
        url: '',
        children: [
          {
            id: '280',
            sort: '',
            name: 'Страница внутри 2ур.',
            is_page: true,
            is_section: true,
            tag: [],
            url: '/event/menedzher-novostey/',
            children: [],
          },
        ],
      },
      {
        id: '41',
        sort: '490',
        name: 'Тестовый раздел сортировка 490',
        is_toggle: false,
        is_section: true,
        is_page: false,
        url: '',
        children: [
          {
            id: '281',
            sort: '',
            name: 'Страница внутри 2ур.',
            is_page: true,
            is_section: true,
            tag: [],
            url: '/event/kontent-menedzher/',
            children: [],
          },
        ],
      },
      {
        id: '40',
        sort: '500',
        name: 'Тестовый раздел сортировка 500',
        is_toggle: false,
        is_section: true,
        is_page: false,
        url: '',
        children: [
          {
            id: '270',
            sort: '500',
            name: 'Страница внутри 2ур. сортировка 500',
            is_page: true,
            is_section: true,
            tag: [],
            url: '/event/testovaya-stranitsa-1/',
            children: [],
          },
          {
            id: '271',
            sort: '490',
            name: 'Страница внутри 2ур. сортировка 490',
            is_page: true,
            is_section: true,
            tag: [],
            url: '/event/testovaya-stranitsa-2/',
            children: [],
          },
          {
            id: '272',
            sort: '480',
            name: 'Страница внутри 2ур. сортировка 480',
            is_page: true,
            is_section: true,
            tag: [],
            url: '/event/testovaya-stranitsa-3/',
            children: [],
          },
          {
            id: '273',
            sort: '470',
            name: 'Страница внутри 2ур. сортировка 470',
            is_page: true,
            is_section: true,
            tag: [],
            url: '/event/testovaya-stranitsa-4/',
            children: [],
          },
          {
            id: '274',
            sort: '460',
            name: 'Страница внутри 2ур. сортировка 460',
            is_page: true,
            is_section: true,
            tag: [],
            url: '/event/testovaya-stranitsa-5/',
            children: [],
          },
        ],
      },
      {
        id: '275',
        sort: '500',
        name: 'Тестовая страница без раздела сортировка 500',
        is_page: true,
        is_section: true,
        tag: [],
        url: '/event/testovaya-stranitsa-bez-razdela-1/',
        children: [],
      },
      {
        id: '276',
        sort: '490',
        name: 'Тестовая страница без раздела сортировка 490',
        is_page: true,
        is_section: true,
        tag: [],
        url: '/event/testovaya-stranitsa-bez-razdela-2/',
        children: [],
      },
      {
        id: '277',
        sort: '480',
        name: 'Тестовая страница без раздела сортировка 480',
        is_page: true,
        is_section: true,
        tag: [],
        url: '/event/testovaya-stranitsa-bez-razdela-3/',
        children: [],
      },
      {
        id: '278',
        sort: '400',
        name: 'Тестовая страница без раздела сортировка 400',
        is_page: true,
        is_section: true,
        tag: [],
        url: '/event/testovaya-stranitsa-bez-razdela-4/',
        children: [],
      },
      {
        id: '279',
        sort: '460',
        name: 'Тестовая страница без раздела сортировка 460',
        is_page: true,
        is_section: true,
        tag: [],
        url: '/event/testovaya-stranitsa-bez-razdela-5/',
        children: [],
      },
    ],
  },
];

export const fakeTags = {
  '34': { id: '34', name: 'MBA', code: 'mba', is_main: true },
  '35': {
    id: '35',
    name: 'Бизнес-коучинг',
    code: 'biznes-kouching',
    is_main: true,
  },
  '36': { id: '36', name: 'CIMA', code: 'cima', is_main: true },
  '37': { id: '37', name: 'ДипИФР', code: 'dipifr', is_main: true },
  '38': { id: '38', name: 'ACCA', code: 'acca', is_main: true },
  '39': {
    id: '39',
    name: 'Личная эффективность',
    code: 'lichnaya-effektivnost',
    is_main: true,
  },
  '40': { id: '40', name: 'HR', code: 'hr', is_main: true },
  '41': { id: '41', name: 'РСБУ и МСФО', code: 'rsbu-i-msfo', is_main: true },
  '42': { id: '42', name: 'Agile', code: 'agile', is_main: true },
  '43': {
    id: '43',
    name: 'Data Analytics',
    code: 'data-analytics',
    is_main: true,
  },
  '44': {
    id: '44',
    name: 'Дизайн-мышление',
    code: 'dizayn-myshlenie',
    is_main: true,
  },
  '45': {
    id: '45',
    name: 'Внутренний аудит',
    code: 'vnutrenniy-audit',
    is_main: true,
  },
  '46': {
    id: '46',
    name: 'Финансовый менеджмент',
    code: 'finansovyy-menedzhment',
    is_main: true,
  },
  '47': {
    id: '47',
    name: 'Управление проектами',
    code: 'upravlenie-proektami',
    is_main: true,
  },
  '48': {
    id: '48',
    name: 'Профессиональные квалификации',
    code: 'professionalnye-kvalifikatsii',
    is_main: true,
  },
  '49': {
    id: '49',
    name: 'Обучение для руководителей',
    code: 'obuchenie-dlya-rukovoditeley',
    is_main: true,
  },
  '50': { id: '50', name: 'Роботизация', code: 'robotizatsiya', is_main: true },
  '51': {
    id: '51',
    name: 'Управление командой',
    code: 'upravlenie-komandoy',
    is_main: true,
  },
  '52': {
    id: '52',
    name: 'Управление компанией',
    code: 'upravlenie-kompaniey',
    is_main: true,
  },
  '53': {
    id: '53',
    name: 'Лидер в цифровую эпоху',
    code: 'digital',
    is_main: true,
  },
  '54': {
    id: '54',
    name: 'Process Mining',
    code: 'process-mining',
    is_main: true,
  },
  '55': {
    id: '55',
    name: 'Управленческий учет',
    code: 'upravlencheskiy-uchet',
    is_main: true,
  },
  '56': { id: '56', name: 'Отчеты', code: 'otchety', is_main: true },
  '243': {
    id: '243',
    name: 'Корпоративные финансы',
    code: 'korporativnye-finansy',
    is_main: false,
  },
  '244': { id: '244', name: 'Excel', code: 'excel', is_main: false },
  '245': {
    id: '245',
    name: 'Бюджетирование',
    code: 'byudzhetirovanie',
    is_main: false,
  },
  '246': {
    id: '246',
    name: 'Финансовое планирование',
    code: 'finansovoe-planirovanie',
    is_main: false,
  },
  '247': {
    id: '247',
    name: 'Внутренний контроль',
    code: 'vnutrenniy-kontrol',
    is_main: false,
  },
  '248': { id: '248', name: 'IPO', code: 'ipo', is_main: false },
  '249': {
    id: '249',
    name: 'Слияния и поглощения',
    code: 'sliyaniya-i-pogloshcheniya',
    is_main: false,
  },
  '250': { id: '250', name: 'Налоги', code: 'nalogi', is_main: false },
  '251': {
    id: '251',
    name: 'Операционная эффективность',
    code: 'operatsionnaya-effektivnost',
    is_main: false,
  },
  '252': {
    id: '252',
    name: 'Оценка бизнеса',
    code: 'otsenka-biznesa',
    is_main: false,
  },
  '253': {
    id: '253',
    name: 'Привлечение инвестиций',
    code: 'privlechenie-investitsiy',
    is_main: false,
  },
  '254': { id: '254', name: 'Стратегия', code: 'strategiya', is_main: false },
  '255': {
    id: '255',
    name: 'Финансовая информация',
    code: 'finansovaya-informatsiya',
    is_main: false,
  },
  '256': {
    id: '256',
    name: 'IT Информационные технологии',
    code: 'it-informatsionnye-tekhnologii',
    is_main: false,
  },
  '257': {
    id: '257',
    name: 'Риск-менеджмент',
    code: 'risk-menedzhment',
    is_main: false,
  },
  '258': {
    id: '258',
    name: 'Отраслевая специализация',
    code: 'otraslevaya-spetsializatsiya',
    is_main: false,
  },
  '259': {
    id: '259',
    name: 'Эффективная коммуникация',
    code: 'effektivnaya-kommunikatsiya',
    is_main: false,
  },
  '260': {
    id: '260',
    name: 'Казначейство',
    code: 'kaznacheystvo',
    is_main: false,
  },
  '261': {
    id: '261',
    name: 'Финансовое моделирование',
    code: 'finansovoe-modelirovanie',
    is_main: false,
  },
  '262': {
    id: '262',
    name: 'Power Point',
    code: 'power-point',
    is_main: false,
  },
  '263': {
    id: '263',
    name: 'Оптимизация затрат',
    code: 'optimizatsiya-zatrat',
    is_main: false,
  },
  '264': {
    id: '264',
    name: 'Финансовая отчетность',
    code: 'finansovaya-otchetnost',
    is_main: false,
  },
  '265': {
    id: '265',
    name: 'Публичные выступления',
    code: 'publichnye-vystupleniya',
    is_main: false,
  },
  '266': {
    id: '266',
    name: 'Финансовый анализ',
    code: 'finansovyy-analiz',
    is_main: false,
  },
};
